<div>
  <mat-sidenav-container>
    <mat-sidenav mode="side" [(opened)]="authorListDrawerOpen">
      <div class="left-div" #sidenav>
        <button *ngIf="authorListDrawerOpen && currentAuthor.id" mat-raised-button color="#ff0000" (click)="authorListDrawerOpen = false">
          <mat-icon>arrow_back_ios</mat-icon>
          Hide Authors
        </button>
        <app-authors-list class="component-c1" (author_emitter)="handleAuthorChange($event)"></app-authors-list>
      </div>
    </mat-sidenav>
    <mat-sidenav-content style="background-color: white">
      <div #publicationsDetailContainer>
        <div class="left-div">
          <button *ngIf="!authorListDrawerOpen" mat-raised-button extended color="#00ff00" (click)="authorListDrawerOpen = true">
          <mat-icon>arrow_forward_ios</mat-icon>
          Show Authors
          </button>
        </div>
        <ng-container class="row-container" *ngIf="(currentAuthor.publications && currentAuthor.publications > 0); else noPublications">
          <div class="right-div">
            <h1 id="publicationTitle">{{currentAuthor.id ? 'Publications for ' : ''}}{{currentAuthor.name}}</h1>
            <share-buttons class="center-items" [include]="['linkedin', 'facebook', 'x', 'whatsapp', 'copy', 'reddit','messenger','xing']"
                           [url]="getUrlForAuthor(currentAuthor.slug)"
                           [title]="currentAuthor.name + '\'s  publications page - Bashan Foundation'"
                           [description]="currentAuthor.name + ' is a member of the Bashan Foundation, and has made their work available through the Bashan Foundation\'s open-to-the-public scientific data bank. The foundation has been continuously building trusted digital archives for scholars, who need reliable access to scientific information, in various fields of microbiology and environmental sciences.'"
            ></share-buttons>
          </div>
          <div class="component-c2">
            <app-authors-list-publications-detail [currentAuthor]="currentAuthor" ></app-authors-list-publications-detail>
          </div>
        </ng-container>

        <ng-template #noPublications>
          <div class="right-div">
            <h1 id="publicationTitle">{{currentAuthor.id ? 'Publications for ' : ''}}{{currentAuthor.name}}</h1>
            <p *ngIf="showPlaceholder" class="member-placeholder" style="margin-top:8px; color:rgba(0,0,0,0.6); font-style:italic;">
              Member's content will be added in the future.
            </p>
          </div>
        </ng-template>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
